import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {exportReport} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import {Table} from "@material-ui/core";
import MuiTable from "../common/MuiTable";
import Paper from "@material-ui/core/Paper";
import CardHeader from "@material-ui/core/CardHeader";
import {BlueButton, GreenButton} from "../common/ButtonsConstants";
import {AddCircleOutlineTwoTone} from "@material-ui/icons";
import moment from "moment";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import {red} from "@material-ui/core/colors";
import withStyles from "@material-ui/core/styles/withStyles";
import {
    addRiskRevision,
    deleteRisk,
    riskRevision,
    risks,
    risksAssessment,
    saveOrUpdateRiskAssessment,
    saveOrUpdateRisks
} from "../../util/PlanningApiUtils";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MomentUtils from "@date-io/moment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";

const classes = () => ({
    card: {
        width: '100%',
    },
    avatar: {
        backgroundColor: red[500],
        fontSize: 10,
    },
    'input': {
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            background: 'yellow'
        }
    },
});

function calculate(props) {
    let color = 'black';
    let backgroundColor = 'white';
    if ((['possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'insignificant')
        || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && ['insignificant', 'minor'].includes(props.rowData.inherentRiskConsequence))) {
        color = 'green';
        props.rowData.calculatedInherentRisk = '1 Low';
    } else if ((props.rowData.inherentRiskLikelihood === 'likely' && props.rowData.inherentRiskConsequence === 'insignificant')
        || (['possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'minor')
        || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'moderate')) {
        color = 'yellow';
        backgroundColor = 'gray';
        props.rowData.calculatedInherentRisk = '2 Moderate';
    } else if ((props.rowData.inherentRiskLikelihood === 'certain' && props.rowData.inherentRiskConsequence === 'insignificant')
        || (['certain', 'likely', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'minor')
        || (['likely', 'possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'moderate')
        || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'major')
        || (props.rowData.inherentRiskLikelihood === 'rare' && props.rowData.inherentRiskConsequence === 'catastrophic')
    ) {
        color = 'orange';
        props.rowData.calculatedInherentRisk = '3 High';
    } else if ((props.rowData.inherentRiskLikelihood === 'certain' && props.rowData.inherentRiskConsequence === 'moderate')
        || (['certain', 'likely', 'possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'major')
        || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'catastrophic')
    ) {
        color = 'red';
        props.rowData.calculatedInherentRisk = '4 Acute';
    }
    return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{props.rowData.calculatedInherentRisk}</div>;
}

function calculateRes(props) {
    let color = 'black';
    let backgroundColor = 'white';
    if ((['possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'insignificant')
        || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && ['insignificant', 'minor'].includes(props.rowData.residualRiskConsequence))) {
        color = 'green';
        props.rowData.calculateResidualRisk = '1 Low';
    } else if ((props.rowData.residualRiskLikelihood === 'likely' && props.rowData.residualRiskConsequence === 'insignificant')
        || (['possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'minor')
        || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'moderate')) {
        color = 'yellow';
        backgroundColor = 'gray';
        props.rowData.calculateResidualRisk = '2 Moderate';
    } else if ((props.rowData.residualRiskLikelihood === 'certain' && props.rowData.residualRiskConsequence === 'insignificant')
        || (['certain', 'likely', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'minor')
        || (['likely', 'possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'moderate')
        || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'major')
        || (props.rowData.residualRiskLikelihood === 'rare' && props.rowData.residualRiskConsequence === 'catastrophic')
    ) {
        color = 'orange';
        props.rowData.calculateResidualRisk = '3 High';
    } else if ((props.rowData.residualRiskLikelihood === 'certain' && props.rowData.residualRiskConsequence === 'moderate')
        || (['certain', 'likely', 'possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'major')
        || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'catastrophic')
    ) {
        color = 'red';
        props.rowData.calculateResidualRisk = '4 Acute';
    }
    return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{props.rowData.calculateResidualRisk}</div>;
}

function render(rowData) {
    let color = 'black';
    let backgroundColor = 'white';
    let calculatedInherentRisk = '';
    if ((['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'insignificant')
        || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && ['insignificant', 'minor'].includes(rowData.inherentRiskConsequence))) {
        color = 'green';
        calculatedInherentRisk = '1 Low';
    } else if ((rowData.inherentRiskLikelihood === 'likely' && rowData.inherentRiskConsequence === 'insignificant')
        || (['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'minor')
        || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'moderate')) {
        color = 'yellow';
        backgroundColor = 'gray';
        calculatedInherentRisk = '2 Moderate';
    } else if ((rowData.inherentRiskLikelihood === 'certain' && rowData.inherentRiskConsequence === 'insignificant')
        || (['certain', 'likely', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'minor')
        || (['likely', 'possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'moderate')
        || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'major')
        || (rowData.inherentRiskLikelihood === 'rare' && rowData.inherentRiskConsequence === 'catastrophic')
    ) {
        color = 'orange';
        calculatedInherentRisk = '3 High';
    } else if ((rowData.inherentRiskLikelihood === 'certain' && rowData.inherentRiskConsequence === 'moderate')
        || (['certain', 'likely', 'possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'major')
        || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'catastrophic')
    ) {
        color = 'red';
        calculatedInherentRisk = '4 Acute';
    }
    return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{calculatedInherentRisk}</div>;
}

function renderRes(rowData) {
    let color = 'black';
    let backgroundColor = 'white';
    let calculateResidualRisk = '';
    if ((['possible', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'insignificant')
        || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && ['insignificant', 'minor'].includes(rowData.residualRiskConsequence))) {
        color = 'green';
        calculateResidualRisk = '1 Low';
    } else if ((rowData.residualRiskLikelihood === 'likely' && rowData.residualRiskConsequence === 'insignificant')
        || (['possible', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'minor')
        || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'moderate')) {
        color = 'yellow';
        backgroundColor = 'gray';
        calculateResidualRisk = '2 Moderate';
    } else if ((rowData.residualRiskLikelihood === 'certain' && rowData.residualRiskConsequence === 'insignificant')
        || (['certain', 'likely', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'minor')
        || (['likely', 'possible', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'moderate')
        || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'major')
        || (rowData.residualRiskLikelihood === 'rare' && rowData.residualRiskConsequence === 'catastrophic')
    ) {
        color = 'orange';
        calculateResidualRisk = '3 High';
    } else if ((rowData.residualRiskLikelihood === 'certain' && rowData.residualRiskConsequence === 'moderate')
        || (['certain', 'likely', 'possible', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'major')
        || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'catastrophic')
    ) {
        color = 'red';
        calculateResidualRisk = '4 Acute';
    }
    return <span style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{calculateResidualRisk}</span>;
}

class Risk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            assId: "",
            orgName: "",
            completedBy: "",
            conductedOn: "",
            risks: [],
            assessment: {},
            latestRevision: {},
            isEditing: false,
        };
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.export = this.export.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadRisks = this.loadRisks.bind(this);
        this.editRiskAssessment = this.editRiskAssessment.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
    }

    componentDidMount() {
        this.loadRisks();
    }

    editRiskAssessment() {
        this.setState({
            isEditing: true,
        });
    }

    loadRisks() {
        risks()
            .then(response => {
                console.log(response);
                this.setState({
                    risks: response,
                });
                riskRevision()
                    .then( revisionResponse => {
                        this.setState({
                            latestRevision: revisionResponse,
                            isLoading: false,
                        });
                        risksAssessment()
                            .then( response => {
                                this.setState({
                                    assessment: response,
                                    assId: response.id,
                                    orgName: response.orgName,
                                    completedBy: response.completedBy,
                                    conductedOn: response.conductedOn,
                                    isLoading: false,
                                });
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({ show: true });
    }

    addRevision(request) {
        addRiskRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    isValid(newData) {
        /*let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;*/
        // for now its always valid
        return true;
    }

    onDelete(record) {
        console.log(record);
        deleteRisk(record)
            .then(() => {
                NotificationManager.success('Success', 'The Comprehensive Risk has been removed.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onSave(data) {
        saveOrUpdateRisks(data)
            .then((updatedRecord) => {
                this.loadRisks();
                NotificationManager.success('Success', 'The Comprehensive Risks have been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("Submitted");
        const updateRequest = Object.assign(
            this.state.assessment,
            {
                id: this.state.assId,
                orgName: this.state.orgName,
                completedBy: this.state.completedBy,
                conductedOn: this.state.conductedOn,
            }
        );
        console.log(updateRequest);
        saveOrUpdateRiskAssessment(updateRequest)
            .then(() => {
                this.setState({
                    isEditing: false,
                });
                NotificationManager.success('Success', 'The Risk Assessment details have been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            conductedOn: moment(date, "DD/MM/YYYY"),
        });
    }

    export() {
        exportReport('/planning/risks/export');
    }

    render() {
        const { classes } = this.props;
        const { state } = this;
        const { show, latestRevision, assessment } = this.state;
        const muiColumnsHazards = [
            { title: 'RISK', field: 'risk', headerStyle: { background: "lightblue", width: "10%" }, width: "10%"},
            { title: 'CONSEQUENCE',
                field: 'inherentRiskConsequence',
                headerStyle: { background: "lightblue" },
                lookup: { insignificant : 'Insignificant' , minor : 'Minor', moderate: 'Moderate', major: 'Major', catastrophic: 'Catastrophic' },
            },
            {
                title: 'LIKELIHOOD',
                field: 'inherentRiskLikelihood',
                headerStyle: { background: "lightblue" },
                lookup: { certain : 'Almost certain' , likely : 'Likely', moderate: 'Moderate', unlikely: 'Unlikely', rare: 'Rare' },
            },
            {
                title: 'INHERENT RISK RATING',
                field: 'calculatedInherentRisk',
                editComponent: (props) => calculate(props),
                render: (rowData) => render(rowData)
            },
            { title: 'CONTROLS/OPPORTUNITIES', field: 'controls', type: "textarea", headerStyle: { background: "lightblue" }},
            { title: 'CONSEQUENCE',
                field: 'residualRiskConsequence',
                headerStyle: { background: "lightblue" },
                lookup: { insignificant : 'Insignificant' , minor : 'Minor', moderate: 'Moderate', major: 'Major', catastrophic: 'Catastrophic' },
            },
            {
                title: 'LIKELIHOOD',
                field: 'residualRiskLikelihood',
                headerStyle: { background: "lightblue" },
                lookup: { certain : 'Almost certain' , likely : 'Likely', moderate: 'Moderate', unlikely: 'Unlikely', rare: 'Rare' },
            },
            {
                title: 'RESIDUAL RISK RATING',
                field: 'calculateResidualRisk',
                editComponent: (props) => calculateRes(props),
                render: (rowData) => renderRes(rowData)
            },
            { title: 'RESPONSIBILITY', field: 'responsibility', headerStyle: { background: "lightblue" }},
            { title: 'COMPLETION DATE', field: 'completionDate', type: "date", headerStyle: { background: "lightblue" }},
        ];
        const isRevision = latestRevision.date && latestRevision.author && latestRevision.approvedBy;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                <span style={{color: "darkblue"}}>
                    <p><b>COMPREHENSIVE RISK ASSESSMENT</b></p>
                </span>
            </Typography>
            <Card className={classes.card}>
                <CardHeader
                    action={
                        <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<AddCircleOutlineTwoTone/>}
                            onClick={this.showModal}
                            size="small"
                            style={{marginRight: '10px'}}
                        >
                            ADD REVISION
                        </BlueButton>
                    }
                    title={
                        <span style={{color: "darkblue"}}>
                            <p><b>{latestRevision.title}</b></p>
                            <p>{isRevision && `Revision ${latestRevision.number} Author: ${latestRevision.author}`}</p>
                        </span>
                    }
                    subheader={
                        isRevision &&
                        <span>
                            <p>Approved for suitability and adequacy by: {latestRevision.approvedBy} on {moment(latestRevision.date).format('DD/MM/YYYY')}</p>
                        </span>
                    }
                />
                <Typography style={{ paddingLeft: '15px'}}>
                    <React.Fragment>
                        <h2>{ this.state.isEditing ? <TextField
                            variant="outlined"
                            margin="normal"
                            style={{ width: "600px", marginTop: "-16px", marginBottom: "24px"}}
                            id="orgName"
                            value={state.orgName}
                            label=""
                            name="orgName"
                            onChange={ this.handleChange }
                            placeholder="&lt;Insert the Name of the Organisation&gt;"
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        /> : <React.Fragment>{ assessment.orgName ? assessment.orgName : <span style={{background: "grey", color: "yellow"}}>&lt;INSERT THE NAME OF THE ORGANISATION&gt;</span>}</React.Fragment>} RISK ASSESSMENT</h2>
                        <p>Risk assessment completed by: { this.state.isEditing ? <TextField
                            variant="outlined"
                            margin="normal"
                            style={{ width: "600px", marginTop: "-16px", marginBottom: "24px"}}
                            id="completedBy"
                            value={state.completedBy}
                            label=""
                            name="completedBy"
                            onChange={ this.handleChange }
                            placeholder="&lt;Completed By&gt;"
                            InputProps={{ classes: {input: this.props.classes['input']} }}
                        /> : <span>{assessment.completedBy ? assessment.completedBy :
                            <span style={{
                                background: "grey",
                                color: "yellow"
                            }}>&lt;COMPLETED BY&gt;</span>}</span>}</p>
                        <p>Assessment conducted on: {this.state.isEditing ? <MuiPickersUtilsProvider utils={MomentUtils}><KeyboardDatePicker
                                    disableToolbar
                                    autoOk
                                    variant="inline"
                                    orientation="landscape"
                                    format="DD/MM/YYYY"
                                    margin="normal"
                                    id="conductedOn"
                                    label="Date"
                                    name="conductedOn"
                                    value={state.conductedOn}
                                    onChange={ this.onDateChange }
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{marginTop: '-20px', marginLeft: '10px'}}
                                    InputProps={{ classes: {input: this.props.classes['input']} }}
                                />
                            </MuiPickersUtilsProvider> :
                            <span>{assessment.conductedOn ? moment(assessment.conductedOn).format('DD/MM/YYYY') :
                                <span style={{
                                    background: "grey",
                                    color: "yellow"
                                }}>&lt;CONDUCTED ON&gt;</span>}</span>}</p>
                    </React.Fragment>
                {!this.state.isEditing ?
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={isAuditor}
                        onClick={this.editRiskAssessment}
                    >
                        Edit
                    </Button>
                    :
                    <GreenButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={this.handleSubmit}
                    >
                        Save
                    </GreenButton>
                }
                </Typography>
                <CardContent style={{ paddingTop: '30px'}}>
                    <Table>
                        <TableHead style={{ backgroundColor: "lightblue" }}>
                            <tr style={{ textAlign: "left" }}>
                                <th style={{ padding: "20px" }} colSpan="6">The risk assessment template can be found on the following page.  The Risk table outlined below defines each risk which is required when conducting a risk assessment.</th>
                            </tr>
                            <tr>
                                <th colSpan="6" style={{padding: "20px", width: "20%"}}>Consequence</th>
                            </tr>
                        </TableHead>
                        <TableBody>
                            <tr>
                                <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Likelihood</td>
                                <td style={{ padding: "20px" }}>Insignificant (Minor problem easily handled by normal day to day processes)</td>
                                <td style={{ padding: "20px" }}>Minor (Some disruption possible e.g. damage equal to $5,000).</td>
                                <td style={{ padding: "20px" }}>Moderate (Significant time/resources required e.g. damage equal to $10,000)</td>
                                <td style={{ padding: "20px" }}>Major (Operations severely damaged e.g. damage equal to $10,001 - $50,000)</td>
                                <td style={{ padding: "20px" }}>Catastrophic (Business survival is at risk  e.g. >$50,001)</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Almost certain (>90% chance)</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Likely (50%-90% chance)</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>MODERATE</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Moderate (10-50%)</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>LOW</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>MODERATE</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Unlikely (3-10%)</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>LOW</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>LOW</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>MODERATE</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "red" }}>EXTREME</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Rare (&lt;3%)</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>LOW</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>LOW</td>
                                <td style={{ padding: "20px", backgroundColor: "green" }}>MODERATE</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                                <td style={{ padding: "20px", backgroundColor: "orange" }}>HIGH</td>
                            </tr>
                        </TableBody>
                    </Table>
                    <hr/>
                    <Paper square>
                        <MuiTable
                            title=""
                            columns={muiColumnsHazards}
                            data={state.risks}
                            onAdd={this.onSave}
                            onUpdate={this.onSave}
                            onDelete={this.onDelete}
                            isValid={this.isValid}
                            exportButton={!isDemo}
                            onExport={this.export}
                            search={false}
                            pageSize={10}
                            headerStyle={{ background: "lightblue" }}
                            allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                        />
                    </Paper>
                </CardContent>
            </Card>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.show}
                onClose={() => this.closeModal(null)}
            >
                <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
            </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(Risk);
